import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/plastic.css'; // Assuming you are already using a custom CSS file
import Led1 from '../assets/images/led1.jpg';
import Led2 from '../assets/images/led2.jpg';
import Led3 from '../assets/images/led3.jpg';
import Led4 from '../assets/images/led4.jpg';
import Led5 from '../assets/images/led5.jpg';
import Led6 from '../assets/images/led6.jpg';
import Led7 from '../assets/images/led7.jpg';
import Led8 from '../assets/images/led8.jpg';
import Led9 from '../assets/images/led9.jpg';

const Led = () => {
  const [customStyle, setCustomStyle] = useState(false); // Track the style toggle

  const images = [
    Led1,
    Led2,
    Led3,
    Led4,
    Led5,
    Led6,
    Led7,
    Led8,
    Led9,
  ];

  // Toggle custom styling
  const switchStyle = () => {
    setCustomStyle(!customStyle);
  };

  return (
    < div >
       <section className="about-container"> <h1>LED TV</h1></section>
       <br/><br/>
       <div className="acer-container">
      {/* Gallery with hover animation */}
      <div className={`row ${customStyle ? "hover-effect-2" : "hover-effect-1"}`} id="gallery">
        {images.map((src, index) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
            <img
              className="w-100 hover-img"
              src={src}
              alt={`Slide ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Led;
